// will match e.g. the following (where xxx is the tenantSubdomain):
// - xxx.localhost
// - xxx.pfxinc.com
// - xxx.qa-eauction.pfxinc.us
// - xxx.dev-eauction.pfxinc.us
export function parseTenantSubdomain() {

  function removeSuffix(s, suffix) {
    if (s.endsWith(suffix)) {
      s = s.substring(0, s.length - suffix.length)
    }
    return s
  }

  // just for local development: ability to override tenant subdomain with parameter, e.g. http://localhost:8000/?subdomain=foobar
  const href = window.location.href + '&'
  const match = href.match(/subdomain=(.+)&/)
  if (match) {
    const subdomain = match[1]
    console.log('request param overrides: subdomain [%s]', subdomain)
    return subdomain
  }

  let hostname = window.location.hostname.toLowerCase()
  hostname = removeSuffix(hostname, 'pfxinc.localhost')
  hostname = removeSuffix(hostname, 'localhost')
  hostname = removeSuffix(hostname, 'www.pfxinc.com')
  hostname = removeSuffix(hostname, 'pfxinc.com')
  hostname = removeSuffix(hostname, 'pfxinc.co')
  hostname = removeSuffix(hostname, 'pfxinc.us')
  hostname = removeSuffix(hostname, 'pfxdemo.com')
  hostname = removeSuffix(hostname, 'demo-eauction.pfxinc.us')
  hostname = removeSuffix(hostname, 'qa-eauction.pfxinc.us')
  hostname = removeSuffix(hostname, 'dev-eauction.pfxinc.us')
  hostname = removeSuffix(hostname, '.')

  if (hostname === '') {
    return '#pfx'
  }
  return hostname
}

export function currentDate(){
  let date = new Date()
  return date
}

export function isUserProfileIncomplete(userProfile) {
  if (!userProfile) { userProfile = {} }
  return !userProfile.firstName
    || !userProfile.lastName
    || !userProfile.email
    || !userProfile.phone
}

export function isCompanyProfileIncomplete(user, tenant) {
  if (!user) { user = {} }
  if (!tenant) { tenant = {} }
  if (user.role === 'ADMIN' && user.tenant === tenant.subdomain) {
    if (!tenant.data) return false
    return !tenant.data.name
      || !tenant.data.dreNumber
      || !tenant.data.address
      || !tenant.data.officePhone
      || !tenant.data.introduction
  }
  return false
}

export function tenantLogoUrl(tenantProfile) {
  if (tenantProfile) {
    if (tenantProfile.extLogoUrl) {
      return tenantProfile.extLogoUrl
    }
    if (tenantProfile.logoUrl) {
      return tenantProfile.logoUrl
    }
  }
  return require('../assets/placeholder-logo.png')
}

export function jumpToTenantWebsiteIfNeeded(auction, store) {
  const id = auction.id
  const currentTenant = store.state.tenant.subdomain
  const subdomain = auction.tenant.subdomain
  if (subdomain !== currentTenant) {
    const pfxLandingPage = process.env.config.frontend.pfxLandingPage
    const tenantLandingPage = pfxLandingPage.replace(/\/\//, '//' + subdomain + '.')
    document.location.replace(`${tenantLandingPage}auction/${id}`)
  }
}

export function absoluteAuctionUrl(auction) {
  const id = auction.id
  const subdomain = auction.tenant.subdomain
  const pfxLandingPage = process.env.config.frontend.pfxLandingPage
  const tenantLandingPage = pfxLandingPage.replace(/\/\//, '//' + subdomain + '.')
  return `${tenantLandingPage}auction/${id}`
}

export const tenantStatuses = {
  DRAFT: { value: 'DRAFT', label: 'Draft' },
  ACTIVE: { value: 'ACTIVE', label: 'Active' },
  SUSPENDED: { value: 'SUSPENDED', label: 'Suspended' },
  DELETED: { value: 'DELETED', label: 'Deleted'}
}

export const auctionStatuses = {
  DRAFT: { value: 'DRAFT', label: 'Draft' },
  OPEN: { value: 'OPEN', label: 'Upcoming' },
  FREEZE: { value: 'FREEZE', label: 'Registration Closed' },
  AUCTION: { value: 'AUCTION', label: 'In Auction' },
  PROCESSING: { value: 'PROCESSING', label: 'Processing' },
  IN_ESCROW: { value: 'IN_ESCROW', label: 'In Escrow' },
  SOLD: { value: 'SOLD', label: 'Sold' },
  CANCELLED: { value: 'CANCELLED', label: 'Auction Cancelled' },
  CLOSED: { value: 'CLOSED', label: 'Auction Closed' },
  ARCHIVED: { value: 'ARCHIVED', label: 'Archived' }
}

export function auctionStatusIndex(status) {
  if (status === auctionStatuses.AUCTION.value) return 0
  if (status === auctionStatuses.OPEN.value) return 1
  if (status === auctionStatuses.FREEZE.value) return 2
  if (status === auctionStatuses.PROCESSING.value) return 3
  if (status === auctionStatuses.IN_ESCROW.value) return 4
  if (status === auctionStatuses.SOLD.value) return 5
  if (status === auctionStatuses.CANCELLED.value) return 6
  if (status === auctionStatuses.CLOSED.value) return 7
  if (status === auctionStatuses.DRAFT.value) return 99
  return 100
}

export function auctionStatusLabel(value) {
  if (!value) return ''
  const found = Object.values(auctionStatuses).find(status => status.value === value)
  return found ? found.label : 'UnknownId:' + value
}

export const auctionRoles = {
  TENANT_ADMIN: { value: 'TENANT_ADMIN', label: 'Company Administrator' },
  LISTING_AGENT: { value: 'LISTING_AGENT', label: 'Listing Agent' },
  DELEGATE: { value: 'DELEGATE', label: 'Listing Agent Delegate' },
  SELLING_AGENT: { value: 'SELLING_AGENT', label: 'Selling Agent' },
  ENTRY: { value: 'ENTRY', label: 'Registration Draft' },
  APPLICANT: { value: 'APPLICANT', label: 'Registration Pending' },
  DISQUALIFIED: { value: 'DISQUALIFIED', label: 'Registration Rejected' },
  BUYER: { value: 'BUYER', label: 'Authorized Buyer' },
  BUYER_OBSERVER: { value: 'BUYER_OBSERVER', label: 'Observer' },
  SELLER: { value: 'SELLER', label: 'Seller' },
  WINNER: { value: 'WINNER', label: 'Winner' },
  ABANDON: { value: 'ABANDON', label: 'Abandoned Winner' },
  ANONYMOUS: { value: 'ANONYMOUS', label: 'Anonymous' }
}

export function auctionRoleLabel(value) {
  if (!value) return ''
  const found = Object.values(auctionRoles).find(type => type.value === value)
  return found ? found.label : 'UnknownId:' + value
}

export const fileVisibility = {
  PUBLIC: { value: 'PUBLIC', label: 'Public' },
  LOGGED_IN: { value: 'LOGGED_IN', label: 'Logged-In' },
  AUTHORIZED: { value: 'AUTHORIZED', label: 'Authorized' },
  PRIVATE: { value: 'PRIVATE', label: 'Private' }
}

export function fileVisibilityLabel(value) {
  if (!value) return ''
  const found = Object.values(fileVisibility).find(type => type.value === value)
  return found ? found.label : 'UnknownId:' + value
}

export function fileDocTypeLabel(id, array) {
  if (!id) return ''
  const found = array.find(doc => doc.id === id)
  return found ? found.text : 'UnknownId:' + id
}

export const auctionInvitationRoles = {
  BUYER: { value: 'BUYER' },
  SELLING_AGENT: { value: 'SELLING_AGENT' },
  BUYER_OBSERVER: { value: 'BUYER_OBSERVER' },
  SELLER: { value: 'SELLER' }
}

export const tenantRoles = {
  ADMIN: { value: 'ADMIN' },
  AGENT: { value: 'AGENT' },
  ASSISTANT: { value: 'ASSISTANT' },
  SUSPENDED: { value: 'SUSPENDED' },
  DELETED: {value: 'DELETED'},
  ANONYMOUS: { value: 'ANONYMOUS' }
}

export const auctionTypes = {
  MINIMUM_BID: { value: 'MINIMUM_BID', label: 'Minimum bid auction' }
}

export function auctionTypeLabel(value) {
  if (!value) return ''
  const found = Object.values(auctionTypes).find(type => type.value === value)
  return found ? found.label : 'UnknownId:' + value
}

export const agencyRelationships = {
  LISTING_AGENT: { value: 'LISTING_AGENT', label: 'I accept Dual Agency and do not have my own Agent' },
  MYSELF: { value: 'MYSELF', label: 'I am an Agent representing myself' },
  SELLING_AGENT: { value: 'SELLING_AGENT', label: 'I have my own Agent' }
}

export function agencyRelationshipLabel(value) {
  if (!value) return ''
  const found = Object.values(agencyRelationships).find(type => type.value === value)
  return found ? found.label : 'UnknownId:' + value
}

export const propertyTypes = [
  { value: 'OFFICE', label: 'Office' },
  { value: 'RETAIL', label: 'Retail' },
  { value: 'INDUSTRIAL', label: 'Industrial' },
  { value: 'LAND', label: 'Land' },
  { value: 'MULTIFAMILY', label: 'Multifamily' },
  { value: 'SPECIAL_PURPOSE', label: 'Special purpose' },
  { value: 'HOSPITALITY', label: 'Hospitality' },
  { value: 'RESIDENTIAL', label: 'Residential' }
]

export function propertyTypeLabel(value) {
  if (!value) return ''
  const found = propertyTypes.find(type => type.value === value)
  return found ? found.label : 'UnknownId:' + value
}

export const usStates = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
]

export const supportPhone = process.env.config.frontend.supportPhone
export const supportEmail = process.env.config.frontend.supportEmail



// WEBPACK FOOTER //
// ./src/utils/PfxUtils.js